import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id EC57EC60-1C8E-45CE-BF4A-D019AFD1F148
 * name stop-circle
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stop-circle.svg
 * tags
 */
export const StopCircleIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M9,9H15V15H9" /></>, 'StopCircleIcon');
export default StopCircleIcon